import CacheStatus from './CacheStatus';

// The shape of message generated by cache installer
export interface CacheMessage {
    cacheEvent?: CacheEventType;
    resource?: string;
    error?: string;
    cacheVersion?: string;
    cachesCleaned?: string[];
    stack?: string;
    status?: CacheStatus;
}

// The cache event type
export enum CacheEventType {
    Checking = 0,
    Downloading = 1,
    Progress = 2,
    Error = 3,
    Cached = 4,
    NoUpdate = 5,
    Obsolete = 6,
    UpdateReady = 7,
    Idle = 8,
    UnCached = 9,
    CleanupError = 10,
    CleanupSuceeded = 11,
    ManifestDate = 12,
}
